
import React from "react";
import styled from "styled-components";
import useStore from "../Store";

const MainDiv = styled.nav`
    width: 15%;
    min-width: 185px;
    height: 80%;
    margin: 20px 0 0 10px;
    padding: 14px 10px;
    box-sizing: border-box;

    background: linear-gradient(
            160deg,
            #079447 0%,
            #04783a 50%,
            #005c35 100%
    );

    border-radius: 16px;
    box-shadow: 0 8px 25px rgba(0, 80, 40, 0.18);

    display: flex;
    flex-direction: column;
    gap: 6px;

    overflow-y: auto;
    overflow-x: hidden;

    @media (max-width: ${({ $screenWidth }) => $screenWidth}) {
        width: 100%;
        min-width: 0;
        height: auto;
        margin: 10px 0;
        padding: 8px;

        flex-direction: row;
        align-items: center;

        border-radius: 12px;
        overflow-x: auto;
        overflow-y: hidden;
        gap: 5px;
    }
`;

const MenuItem = styled.button`
    width: 100%;
    min-height: 44px;
    padding: 12px 14px;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: center;

    background: ${({ $active }) =>
    $active ? "#ffffff" : "transparent"};

    color: ${({ $active }) =>
    $active ? "#04783a" : "#ffffff"};

    border: 1px solid
        ${({ $active }) =>
    $active
        ? "rgba(255,255,255,0.9)"
        : "transparent"};

    border-radius: 10px;

    font-family: "Segoe UI", sans-serif;
    font-size: 15px;
    font-weight: ${({ $active }) =>
    $active ? 600 : 400};

    line-height: 1.35;
    text-align: center;

    cursor: pointer;
    flex-shrink: 0;

    transition:
        background-color 0.2s ease,
        color 0.2s ease,
        transform 0.2s ease,
        box-shadow 0.2s ease;

    box-shadow: ${({ $active }) =>
    $active
        ? "0 3px 12px rgba(0,0,0,0.12)"
        : "none"};

    &:hover {
        background: ${({ $active }) =>
    $active
        ? "#ffffff"
        : "rgba(255,255,255,0.15)"};

        transform: translateY(-1px);
    }

    &:active {
        transform: scale(0.98);
    }

    &:focus-visible {
        outline: 2px solid #ffffff;
        outline-offset: 3px;
    }

    @media (max-width: ${({ $screenWidth }) => $screenWidth}) {
        width: auto;
        min-height: 40px;
        padding: 9px 14px;

        font-size: 14px;
        white-space: nowrap;
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }
`;

const PagesMenu = ({
                       selectedPage,
                       setSelectedPage,
                       setSelectedSubpage
                   }) => {
    const Pages = useStore((state) => state.PagesData);
    const Language = useStore((state) => state.Language);
    const Languages = useStore((state) => state.Languages);
    const ScreenWidthForMobile = useStore(
        (state) => state.ScreenWidthForMobile
    );

    const screenWidth =
        typeof ScreenWidthForMobile === "number"
            ? `${ScreenWidthForMobile}px`
            : ScreenWidthForMobile;

    function setPage(page) {
        setSelectedPage(page);
        setSelectedSubpage(false);

        if (page === "Subsidiary") {
            setSelectedSubpage("Show subsidiaries");
        }
    }

    return (
        <MainDiv
            $screenWidth={screenWidth}
            aria-label="Pages navigation"
        >
            {Object.keys(Pages).map((element) => (
                <MenuItem
                    key={element}
                    type="button"
                    $active={element === selectedPage}
                    $screenWidth={screenWidth}
                    aria-current={
                        element === selectedPage
                            ? "page"
                            : undefined
                    }
                    onClick={() => setPage(element)}
                >
                    {Pages[element][Languages[Language]]}
                </MenuItem>
            ))}
        </MainDiv>
    );
};

export default PagesMenu;
